import Instagram from "./Instagram";
import Twitter from "./Twitter";
import { useState } from "react";

export default function SocialMedia({ toggleHamburguerMenu }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const hamburguerMenu = () => {
    setIsMenuOpen(!isMenuOpen); 
    toggleHamburguerMenu(!isMenuOpen);
  };

  return (
    <div>
      <section className="gap-4 items-center hidden lg:flex ">
        <Twitter />
        <Instagram />
      </section>
      <section className="flex flex-col lg:gap-4 block lg:hidden items-center ">
        <button onClick={hamburguerMenu}
          className="flex justify-center items-center bg-purple-750 hover:bg-purple-800 w-[26px] h-[24px] rounded-[3px]">
          <img
            src="/assets/icons/hamburger-menu.svg"
            width={24}
            height={24}
            alt="Menu icon"
          />
        </button>
      </section>
    </div>
  );
}
